import React from 'react';
import { Link } from 'gatsby';
import logo from '../../assets/images/logo.png';
import footerMap from '../../assets/images/footer-map.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-area bg-color">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-12">
            <div className="single-footer-widget">
              <a href="/" className="logo">
                <img src={logo} alt="logo" />
              </a>
              <p>
                ByteForge is a technology consultancy firm. We specialize in
                crafting digital solutions for businesses, including web &
                mobile applications, data & AI solutions, user experience
                designs and business automations tailored to your needs.
              </p>

              <ul className="social-link">
                <li>
                  <a
                    href="https://www.linkedin.com/company/byteforgeglobal"
                    className="d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bx bxl-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/byteforgeglobal"
                    className="d-block"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bx bxl-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3">
            <div className="single-footer-widget pl-5">
              <h3>Explore</h3>

              <ul className="footer-links-list">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/portfolio">Our Work</Link>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/byteforgestudio/jobs"
                    target="_blank"
                  >
                    Careers
                  </a>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3">
            <div className="single-footer-widget">
              <h3>Services</h3>

              <ul className="footer-links-list">
                <li>
                  <Link to="/get-started#application-development">
                    Application Development
                  </Link>
                </li>
                <li>
                  <Link to="/get-started#business-automation">
                    Business Automation
                  </Link>
                </li>
                <li>
                  <Link to="/get-started#data-ai">Data & AI</Link>
                </li>
                <li>
                  <Link to="/get-started#cloud">Cloud</Link>
                </li>
                <li>
                  <Link to="/get-started#customer-experience">
                    Customer Experience
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3">
            <div className="single-footer-widget">
              <h3>Legal</h3>

              <ul className="footer-links-list">
                <li>
                  <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/shipping-policy">Shipping Policy</Link>
                </li>
                <li>
                  <Link to="/refund-policy">Refund Policy</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3">
            <div className="single-footer-widget">
              <h3>Get In Touch</h3>

              <ul className="footer-contact-info">
                <li>
                  <i>📞</i>
                  <a href="tel:+923043545344">+92 304 3545344</a>
                </li>
                <li>
                  <i>💬</i>{' '}
                  <a
                    href="https://wa.me/923043545344"
                    target="_blank"
                    rel="noreferrer"
                  >
                    WhatsApp
                  </a>
                </li>
                <li>
                  <i>🌐</i>{' '}
                  <a href="mailto:hello@byteforge.studio">hello@byteforge.studio</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom-area">
          <div className="row align-items-center">
            <div className="col-lg-12 col-md-12">
              <p style={{ textAlign: 'center' }}>
                Copyright © {currentYear} <strong>ByteForge (Pvt) Ltd</strong>
                . All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-map">
        <img src={footerMap} alt="footer-logo" />
      </div>
    </footer>
  );
};

export default Footer;
